
import React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { FormField, FormItem, FormLabel, FormControl, FormDescription } from '@/components/ui/form';
import { FeaturePreview } from '../FeaturePreview';
import { useTranslation } from 'react-i18next';

export function RemindersPreview() {
  const { t } = useTranslation();
  
  const previewContent = (
    <div className="space-y-6">
      <div>
        <h3 className="text-lg font-medium">{t('reminders', 'Reminders')}</h3>
        <p className="text-sm text-muted-foreground">
          {t('setupRemindersForContract', 'Set up reminders for this contract')}
        </p>
      </div>

      <div className="grid gap-4 md:grid-cols-2">
        <FormField
          name="reminderPeriod"
          render={({ field }) => (
            <FormItem>
              <FormLabel>{t('reminderPeriod', 'Reminder Period')}</FormLabel>
              <Select disabled>
                <FormControl>
                  <SelectTrigger>
                    <SelectValue placeholder={t('selectReminderPeriod', 'Select reminder period')} />
                  </SelectTrigger>
                </FormControl>
                <SelectContent>
                  <SelectItem value="1 week">{t('oneWeekBefore', '1 week before')}</SelectItem>
                  <SelectItem value="2 weeks">{t('twoWeeksBefore', '2 weeks before')}</SelectItem>
                  <SelectItem value="1 month">{t('oneMonthBefore', '1 month before')}</SelectItem>
                </SelectContent>
              </Select>
              <FormDescription>
                {t('reminderPeriodDescription', 'How long before expiry to start reminders')}
              </FormDescription>
            </FormItem>
          )}
        />

        <FormField
          name="reminderFrequency"
          render={({ field }) => (
            <FormItem>
              <FormLabel>{t('reminderFrequency', 'Reminder Frequency')}</FormLabel>
              <Select disabled>
                <FormControl>
                  <SelectTrigger>
                    <SelectValue placeholder={t('selectReminderFrequency', 'Select reminder frequency')} />
                  </SelectTrigger>
                </FormControl>
                <SelectContent>
                  <SelectItem value="Once">{t('onceOnly', 'Once only')}</SelectItem>
                  <SelectItem value="Weekly">{t('weekly', 'Weekly')}</SelectItem>
                  <SelectItem value="Monthly">{t('monthly', 'Monthly')}</SelectItem>
                </SelectContent>
              </Select>
              <FormDescription>
                {t('reminderFrequencyDescription', 'How often to send reminders')}
              </FormDescription>
            </FormItem>
          )}
        />
      </div>
    </div>
  );

  return (
    <FeaturePreview
      feature="reminders"
      title={t('reminders', 'Reminders')}
      description={t('remindersDescription', 'Get notified before contracts expire. Set custom reminder periods and frequencies to stay ahead of deadlines.')}
      previewContent={previewContent}
      compact={true}
      translationLinks={[
        { key: 'reminders', text: t('translateThis', 'Translate this') },
        { key: 'remindersDescription', text: t('translateDescription', 'Translate description') }
      ]}
    />
  );
}
